import './card-progress.scss';

export default () => {

};
